import {fabric} from "fabric";
import React from 'react';
import WebFont from 'webfontloader';


class EnglishFonts extends React.Component {
    constructor(props) {
        super(props);
        this.state={showTests:false ,writtenWord:"",language:""}
     
        this.testWord = React.createRef();
        this.fontProperties=React.createRef()
        this.handleGenerateCLick=this.handleGenerateCLick.bind(this);
        this.handleUseFontClick=this.handleUseFontClick.bind(this);

      }
    
    

    componentDidMount(){
         WebFont.load({
             google: {
               families: [...this.props.props.designer.englishFonts,...this.props.props.designer.arabicFonts]
             }
           });
    }
    handleGenerateCLick(e){
        // var testEnglish="";
        // if(this.testWord.current.value.indexOf(' ')>0){
        // testEnglish=input.split(" ");
        // }
        // // var pattern = new RegExp(/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/);
        // if(pattern.test(this.testWord.current.value)){

        // }

        

        var language="Arabic"
        if (/^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]*$/.test(this.testWord.current.value.split(" ")[0])){
            language="English";
        }
        this.setState({showTests:true,testWord:this.testWord.current.value,language:language});
    }
    handleUseFontClick(font){
        const textSample=this.state.testWord;
        const fontType=font;
        const canvas=this.props.props.designer.drawingCanvas;
         var textToAdd = new fabric.Text(textSample, {
             fixedWidth:canvas.width,
		 	left: 0,
		 	top: 0,
		 	fontFamily: fontType,
		 	angle: 0,
		 	fill: '#000000',
		 	fontWeight: 500,
             fontSize:40,
		 	hasRotatingPoint: true,
             lockUniScaling:true,
             objectCaching:false,            
		 });

         if(textToAdd.width>textToAdd.fixedWidth){
             textToAdd.fontSize*=textToAdd.fixedWidth/(textToAdd.width+1);
             textToAdd.width=textToAdd.fixedWidth;
         }

        //  canvas.on('text:changed', function(opt) {
        //     var t1 = opt.target;
        //     if (t1.width > t1.fixedWidth) {
        //       t1.fontSize *= t1.fixedWidth / (t1.width + 1);
        //       t1.width = t1.fixedWidth;
        //     }
        //   });
          
        //  canvas.add(t1);

        canvas.add(textToAdd);
        canvas.setActiveObject(textToAdd);
        if(document.getElementById('shirtSettings'))document.getElementById('shirtSettings').id = 'shirtSettingsShrink';
        //document.getElementById('textEditorButton').style.visibility="visible";
        this.props.props.increasePrice();


         //textToAdd.width=canvas.width;
         //canvas.renderAll();
    }


    render() { 
        return <div style={{height:"100%"}}>
                    <div className="well" style={{margin:"10px",background:"ghostwhite"}}>       
        <label style={{fontWeight:"bold",fontSize:'19px'}}>Input Text Here</label>
        <hr className="rounded" style={{backgroundColor:"black",width:"60%",marginTop:"0px"}}/>
        <input ref={this.testWord} style={{background:"aliceblue",width:"100%",border:"1px solid black",fontSize:'19px'}}/>
        <button className="generateButton" onClick={(e)=>{this.handleGenerateCLick(e)}}><span>Generate</span> </button>
        </div>
{

    this.state.showTests&&(
    <div id="textContainer" >
        { this.state.language!=="Arabic"?(this.props.props.designer.englishFonts.map((font,index)=>(<div id="textContainer" className='well' key={index}><span  style={{fontFamily:font ,fontSize:"25px"}}>{this.state.testWord}</span><br/><button className='generateButton' onClick={(e)=>{this.handleUseFontClick(font)}}><span>Use This Font</span> </button>
</div>))):(this.props.props.designer.arabicFontFamillies.map((font,index)=>(<div id="textContainer" className='well' key={index}><span  style={{fontFamily:font ,fontSize:"25px"}}>{this.state.testWord}</span><br/><button className='generateButton' onClick={(e)=>{this.handleUseFontClick(font)}}><span>Use This Font</span> </button>
</div>)))}
    </div>
    )
    }
        </div>;
    }
}
 
export default EnglishFonts;